import { FC } from "react";

interface HandshakeIconSVGProps {
    className?: string;
}

const HandshakeIconSVG: FC<HandshakeIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="64"
            height="65"
            viewBox="0 0 64 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.3334 45.8337L34.6667 51.167C35.192 51.6923 35.8156 52.109 36.5019 52.3933C37.1882 52.6776 37.9238 52.8239 38.6667 52.8239C39.4096 52.8239 40.1452 52.6776 40.8315 52.3933C41.5178 52.109 42.1414 51.6923 42.6667 51.167C43.192 50.6418 43.6087 50.0181 43.893 49.3318C44.1773 48.6455 44.3236 47.9099 44.3236 47.167C44.3236 46.4242 44.1773 45.6886 43.893 45.0023C43.6087 44.3159 43.192 43.6923 42.6667 43.167M37.3334 37.8337L44 44.5004C45.0609 45.5612 46.4998 46.1572 48 46.1572C49.5003 46.1572 50.9392 45.5612 52 44.5004C53.0609 43.4395 53.6569 42.0007 53.6569 40.5004C53.6569 39.0001 53.0609 37.5612 52 36.5004L41.6534 26.1537C40.1534 24.6556 38.1201 23.8141 36 23.8141C33.88 23.8141 31.8467 24.6556 30.3467 26.1537L28 28.5004C26.9392 29.5612 25.5003 30.1572 24 30.1572C22.4998 30.1572 21.0609 29.5612 20 28.5004C18.9392 27.4395 18.3432 26.0007 18.3432 24.5004C18.3432 23.0001 18.9392 21.5612 20 20.5004L27.4934 13.007C29.926 10.5808 33.0984 9.03517 36.5084 8.61496C39.9184 8.19475 43.3711 8.92392 46.3201 10.687L47.5734 11.4337C48.7088 12.119 50.0588 12.3567 51.36 12.1004L56 11.167M56.0001 8.50037L58.6667 37.8337H53.3334M8.00004 8.50037L5.33337 37.8337L22.6667 55.167C23.7276 56.2279 25.1664 56.8239 26.6667 56.8239C28.167 56.8239 29.6058 56.2279 30.6667 55.167C31.7276 54.1062 32.3236 52.6673 32.3236 51.167C32.3236 49.6667 31.7276 48.2279 30.6667 47.167M8.00004 11.167H29.3334"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default HandshakeIconSVG;
